import { forwardRef, useImperativeHandle, useRef } from 'react';

export interface DragPreviewHandle {
  show(t: { pe: { pcx: number; pcy: number; ring: number; gi: number; pi: number }; ang: number; x: number; y: number }, showLabel: boolean, labelText: string): void;
  clear(): void;
}

const DragPreview = forwardRef<DragPreviewHandle>(function DragPreview(_props, ref) {
  const gRef = useRef<SVGGElement | null>(null);

  useImperativeHandle(ref, () => ({
    show(t, showLabel, labelText) {
      const g = gRef.current;
      if (!g) return;
      g.innerHTML = '';
      const NS = 'http://www.w3.org/2000/svg';
      const target = document.createElementNS(NS, 'circle');
      target.setAttribute('class', 'droptarget');
      target.setAttribute('cx', String(t.pe.pcx));
      target.setAttribute('cy', String(t.pe.pcy));
      target.setAttribute('r', String(t.pe.ring));
      const line = document.createElementNS(NS, 'line');
      line.setAttribute('class', 'dropline');
      line.setAttribute('x1', String(t.pe.pcx)); line.setAttribute('y1', String(t.pe.pcy));
      line.setAttribute('x2', String(t.x)); line.setAttribute('y2', String(t.y));
      const ghostRing = document.createElementNS(NS, 'circle');
      ghostRing.setAttribute('class', 'ghostring');
      ghostRing.setAttribute('cx', String(t.x)); ghostRing.setAttribute('cy', String(t.y)); ghostRing.setAttribute('r', '18');
      const ghostDot = document.createElementNS(NS, 'circle');
      ghostDot.setAttribute('class', 'dropdot');
      ghostDot.setAttribute('cx', String(t.x)); ghostDot.setAttribute('cy', String(t.y)); ghostDot.setAttribute('r', '7');
      g.append(target, line, ghostRing, ghostDot);
      if (showLabel) {
        const label = document.createElementNS(NS, 'text');
        label.setAttribute('class', 'droplbl');
        label.setAttribute('x', String(t.pe.pcx));
        label.setAttribute('y', String(t.pe.pcy - t.pe.ring - 14));
        label.textContent = `→ ${labelText}`;
        g.append(label);
      }
    },
    clear() {
      if (gRef.current) gRef.current.innerHTML = '';
    },
  }), []);

  return <g ref={gRef} />;
});

export default DragPreview;
